module.exports = __webpack_public_path__ + "img/beer-1.3e97240e.jpg";